import { render, staticRenderFns } from "./KycSection.vue?vue&type=template&id=47afd940&scoped=true"
import script from "./KycSection.vue?vue&type=script&lang=js"
export * from "./KycSection.vue?vue&type=script&lang=js"
import style0 from "./KycSection.vue?vue&type=style&index=0&id=47afd940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afd940",
  null
  
)

export default component.exports